import React, { createContext, useContext } from "react";

type BusinessContextValue = {
  currentBusiness?: { name?: string } | null;
};

const BusinessContext = createContext<BusinessContextValue>({ currentBusiness: null });

export const BusinessProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <BusinessContext.Provider value={{ currentBusiness: null }}>{children}</BusinessContext.Provider>
);

export const useBusinessContext = () => useContext(BusinessContext);
